module.exports = {"210323001":"阜昌街道","210323003":"兴隆街道","210323004":"雅河街道","210323101":"三家子镇","210323102":"石庙子镇","210323103":"黄花甸镇","210323104":"大营子镇","210323105":"苏子沟镇","210323106":"偏岭镇","210323107":"哈达碑镇","210323108":"新甸镇","210323109":"洋河镇","210323111":"杨家堡镇","210323112":"清凉山镇","210323113":"石灰窑镇","210323114":"前营镇","210323115":"龙潭镇","210323116":"牧牛镇","210323117":"药山镇","210323118":"大房身镇","210323119":"朝阳镇","210323206":"红旗营子乡","210323211":"岭沟乡","210323212":"哨子河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210323.json
// module id = 618
// module chunks = 0